import React from 'react'
import './About.css'
import ME from '../../assets/myself.jpg'
import { FaAward } from 'react-icons/fa'
import { AiOutlineUsergroupAdd } from 'react-icons/ai'
import { AiFillFolderOpen } from 'react-icons/ai'

const About = () => {
  return (
      <section id='about'>
          <h5>Get To Know</h5>
          <h2>About Me</h2>

          <div className="container about__container">
              
              <div className="about__me">
                  <div className="about__me-image">
                      <img src={ME} alt="my--img" />
                  </div>
              </div>

              <div className="about__content">
                  <div className="about__cards">
                      
                      <article className="about__card">
                          <FaAward className='about__icon'/>
                          <h5>Experience</h5>
                          <small>1.5 year Working on mern</small>
                      </article>
                      <article className="about__card">
                          <AiOutlineUsergroupAdd className='about__icon'/>
                          <h5>B.Tech Degree</h5>
                          <small>NIT Patna</small>
                      </article>
                      <article className="about__card">
                          <AiFillFolderOpen className='about__icon'/>
                          <h5>Project</h5>
                          <small>20+ compleated</small>
                      </article>

                  </div>
                  <p>
                      I am divya gaurav qualified b.tech from NIT Patna , during this time i have done lot's of project , an cocurriculam activity which helps me to explore a good foungation of software developement.
                      after my colledge , i compleated full stack developement training at Coding Ninja Career Camp. which covers everything like frontend development , backend development , and full stack web application
                      Proficient in Java, DSA, React,MatrialUI, Node , Express, JavaScript, Mongo db, sql. I Love obsessing over algorithmic problems and making all kinds of project in free time. I am driven software developer who likes to take initiative in any task I am assigned
                  </p>
                  <a href="#contact" className='btn btn-primary'>Let's Talk</a>
              </div>
          </div>
    </section>
  )
}

export default About